exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n}\n\nbody {\n  margin: 0;\n  background: linear-gradient(#000, #010203);\n  color: white;\n}\n\n.loader{\n  margin: 0 0 2em;\n  height: auto;\n  width: 20%;\n  text-align: center;\n  padding: 1em;\n  margin: auto;\n  vertical-align: center;\n}", ""]);

// exports
